import { ChangeEvent, FunctionComponent } from 'react';
import {
  SearchContainer,
  SearchField,
  SearchIcon,
  SearchInputWrap,
} from './AdminFilterPrimitives';

interface AdminSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const AdminSearchInput: FunctionComponent<AdminSearchInputProps> = ({
  value,
  onChange,
  placeholder = '검색어를 입력해주세요.',
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value);

  return (
    <SearchInputWrap>
      <SearchContainer>
        <SearchIcon>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 14L11.1 11.1" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </SearchIcon>
        <SearchField type="text" placeholder={placeholder} value={value} onChange={handleChange} />
      </SearchContainer>
    </SearchInputWrap>
  );
};

export default AdminSearchInput;
